function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree, Modal, Table, Tabs, Input, Alert, Form, DatePicker } from 'antd';
import { NodePlusFill, XSquareFill, TrashFill, PencilFill, BoxArrowInRight, Search, ArrowCounterclockwise, PlusCircleFill, BoxSeamFill, ArrowLeftRight } from 'react-bootstrap-icons';
import Common from "../components/includes/Common";
import AddConnsumable from "../components/forms/AddConsumable";
import AddConsumableCategory from "../components/forms/AddConsumableCategory";
import EditConsumable from "../components/forms/EditConsumable";
import ConsumablesOut from "../components/ConsumablesOut";
import NewProvision from "../components/forms/NewProvision";
import moment from 'moment';
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Consommable = function Consommable() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewDeptFormVisible = _useState2[0],
    setIsNewDeptFormVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewItemFormVisible = _useState4[0],
    setIsNewItemFormVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    soDataChanged = _useState8[0],
    setSoDataChanged = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedItem = _useState0[0],
    setSelectedItem = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    itemProvisionVisible = _useState10[0],
    setItemProvisionVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    itemEditVisible = _useState12[0],
    setItemEditVisible = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemsArray = _useState14[0],
    setItemsArray = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isDataLoading = _useState16[0],
    setIsDataLoading = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSoLoading = _useState18[0],
    setIsSoLoading = _useState18[1];
  var _useState19 = useState(moment().startOf('month').format()),
    _useState20 = _slicedToArray(_useState19, 2),
    from = _useState20[0],
    setFrom = _useState20[1];
  var _useState21 = useState(moment().endOf('month').format()),
    _useState22 = _slicedToArray(_useState21, 2),
    to = _useState22[0],
    setTo = _useState22[1];
  var _useState23 = useState(moment().startOf('month').format()),
    _useState24 = _slicedToArray(_useState23, 2),
    opFrom = _useState24[0],
    setOpFrom = _useState24[1];
  var _useState25 = useState(moment().endOf('month').format()),
    _useState26 = _slicedToArray(_useState25, 2),
    opTo = _useState26[0],
    setOpTo = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    operations = _useState28[0],
    setOperations = _useState28[1];
  var _useState29 = useState(''),
    _useState30 = _slicedToArray(_useState29, 2),
    errorMessage = _useState30[0],
    setErrorMessage = _useState30[1];
  var _useState31 = useState(''),
    _useState32 = _slicedToArray(_useState31, 2),
    keywords = _useState32[0],
    setKeyword = _useState32[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Cat\xE9gorie"
    }),
    dataIndex: "category",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "category"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte Disponible"
    }),
    dataIndex: "available_quantity",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "available_quantity"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Stock Minimale"
    }),
    dataIndex: "minimal_stock",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "minimal_stock"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Actions"
    }),
    dataIndex: "action",
    render: function render(item) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleEditItem(item);
          },
          children: /*#__PURE__*/_jsx(PencilFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleDeleteItem(item);
          },
          children: /*#__PURE__*/_jsx(TrashFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          style: {
            color: '#EF7B7A'
          },
          onClick: function onClick() {
            return handleItemIn(item);
          },
          children: /*#__PURE__*/_jsx(PlusCircleFill, {
            size: 28
          })
        })]
      });
    },
    key: "action"
  }];
  var colsOps = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: "date",
    key: "date",
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Type"
    }),
    dataIndex: "type",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "type"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Article"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte"
    }),
    dataIndex: "quantity",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "quantity"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Auteur"
    }),
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "user"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Actions"
    }),
    dataIndex: "action",
    render: function render(item) {
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleCancelOperation(item);
          },
          children: /*#__PURE__*/_jsx(ArrowCounterclockwise, {
            size: 20
          })
        })
      });
    },
    key: "action"
  }];
  var handleEditItem = function handleEditItem(item) {
    setSelectedItem(item);
    setItemEditVisible(true);
  };
  var handleCancelOperation = function handleCancelOperation(item) {};
  var onSearchOp = function onSearchOp(values) {};
  var handleDeleteItem = function handleDeleteItem(item) {
    setSelectedItem(item);
    Modal.confirm({
      title: "Confirmez-vous ?",
      content: "La suppression de " + item.label,
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteconsumable/" + item.id.toString() + "/" + Common.currentUser.id.toString()).then(function (response) {
          if (response.status == 200) {
            setDataChanged(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  var handleItemIn = function handleItemIn(item) {
    setSelectedItem(item);
    setItemProvisionVisible(true);
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.post(Common.baseApiUrl + 'getconsumables', {
      keywords: keywords,
      user_id: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setItemsArray([]);
        response.data.consumables.forEach(function (s) {
          setItemsArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              id: s.id,
              key: s.id.toString() + "tab",
              label: s.label,
              category: s.category.label,
              cost_price: s.cost_price,
              available_quantity: s.available_quantity,
              minimal_stock: s.minimal_stock,
              action: s
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une arreur est survenue ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged, keywords]);
  useEffect(function () {
    setSoDataChanged(false);
    setIsSoLoading(true);
    axios.get("".concat(Common.baseApiUrl, "getstockoperations/").concat(opFrom, "/").concat(opTo, "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setOperations([]);
        response.data.operations.forEach(function (o) {
          setOperations(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              type: o.type == 0 ? "Sortie" : "Entrée",
              label: o.consumable.label,
              quantity: o.quantity,
              date: o.created_at,
              user: o.user.firstname + " " + o.user.lastname
            }]);
          });
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsSoLoading(false);
    });
  }, [soDataChanged, opFrom, opTo]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                width: '98%',
                background: '#EF7B7A'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewDeptFormVisible(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "Ajouter une categorie"
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                width: '98%',
                background: '#EF7B7A'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewItemFormVisible(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "Ajouter un Consommable"
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Tabs, {
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BoxArrowInRight, {
                  size: 28
                }), " SORTIE"]
              }),
              children: /*#__PURE__*/_jsx(ConsumablesOut, {})
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BoxSeamFill, {
                  size: 28
                }), " ETATS DU STOCK"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx(Input, {
                    size: "middle",
                    placeholder: "Saisir un article",
                    suffix: /*#__PURE__*/_jsx(Search, {
                      style: {
                        color: 'rgba(0,0,0,.45)'
                      }
                    }),
                    onChange: function onChange(e) {
                      setKeyword(e.target.value);
                    }
                  })
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
                  size: "small",
                  columns: cols,
                  bordered: true,
                  sticky: false,
                  loading: isDataLoading,
                  dataSource: itemsArray,
                  pagination: true
                })]
              })
            }, 2), /*#__PURE__*/_jsxs(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ArrowLeftRight, {
                  size: 28
                }), " OPERATIONS"]
              }),
              children: [/*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(Form, {
                  onFinish: onSearchOp,
                  layout: "vertical",
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Form.Item, {
                      name: "period",
                      children: /*#__PURE__*/_jsx(RangePicker, {
                        onChange: function onChange(date, dstring) {
                          setOpFrom(moment(date[0].$d).format());
                          setTo(moment(date[1].$d).format());
                          console.log(date);
                        },
                        variant: "borderless"
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      children: /*#__PURE__*/_jsxs("div", {
                        style: {
                          color: "#B6B5B2"
                        },
                        children: ["DU ", /*#__PURE__*/_jsx(Moment, {
                          date: opFrom,
                          format: "DD/MM/YYYY"
                        }), " AU ", /*#__PURE__*/_jsx(Moment, {
                          date: opTo,
                          format: "DD/MM/YYYY"
                        })]
                      })
                    })]
                  })
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "white-bg cool-radius",
                children: /*#__PURE__*/_jsx(Table, {
                  size: "small",
                  columns: colsOps,
                  bordered: true,
                  sticky: false,
                  loading: isSoLoading,
                  dataSource: operations,
                  pagination: true
                })
              })]
            }, 3)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter une cat\xE9gorie",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddConsumableCategory, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewItemFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un article",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddConnsumable, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: itemEditVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Modifier",
      onCancel: function onCancel() {
        setItemEditVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(EditConsumable, {
        handler: function handler() {
          setDataChanged(true), setItemEditVisible(false);
          message.success({
            content: "Modifications enregistrées",
            delay: 4
          });
        },
        item: selectedItem
      })
    }), /*#__PURE__*/_jsx(Modal, {
      visible: itemProvisionVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Entr\xE9e de Stock",
      onCancel: function onCancel() {
        setItemProvisionVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(NewProvision, {
        item: selectedItem,
        handler: function handler() {
          setDataChanged(true), setItemProvisionVisible(false);
          message.success({
            content: "Opération effectuée",
            delay: 4
          });
        }
      })
    })]
  });
};
export default Consommable;